<template>
    <!-- 提单在线对单 -->
    <div class="page-container">
		<el-form :model="onlineOrderMatchingForm" ref="onlineOrderMatchingFormRef" class="form-panel" label-position="top">
			<el-row class="matching_title">
                提单更正
            </el-row>
            <el-row class="panel-top matching_tip" type="flex" justify="center" align="middle">
                温馨提示:鼠标移动到提单页面高亮内容上, 可点击修改。 以下可编辑提单样式有可能和正式提单格式有所差异，可点击<router-link class="link_go" to=''>“这里”</router-link>查看船公司PDF版本提单。
            </el-row>
            <el-row class="matching-body panel-top">
                <el-col>
                    <el-row class="matching-body-title">
                        <el-col class="matching-body-title-left" :span="16">
                            提单更正可能产生额外费用，请先和港口代理确认
                        </el-col>
                        <el-col class="matching-body-title-right" :span="8">
                            PROFORMA
                        </el-col>
                    </el-row>
                    <el-row class="second">
                        <el-col :span="12" class="common-borderTop common-padding">
                            <span class="common-title">1. Shipper  Insert Name Address and Phone / Address</span>
                            <el-input
                                type="textarea"
                                :rows="5"
                                resize="none"
                                placeholder="请输入内容"
                            >
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="common-borderTopLeft">
                            <el-row>
                                <el-col :span="12" class="common-borderRightBottom common-padding">
                                    <span class="common-title">Booking No.</span>
                                    <span>OOCL2020001</span>
                                </el-col>
                                <el-col :span="12" class="common-borderBottomThin common-padding">
                                    <span class="common-title">Bill of Landing No.</span>
                                    <span>OOCL2020001</span>
                                </el-col>
                            </el-row>
                            <el-row class="common-padding">
                                <span class="common-title">Export References</span>
                                <el-input
                                    type="textarea"
                                    :rows="3"
                                    resize="none"
                                    placeholder="请输入内容"
                                >
                                </el-input>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row class="third">
                        <el-col :span="12" class="common-borderTop common-padding">
                            <span class="common-title">2. Consignee  Insert Name Address and Phone / Address</span>
                            <el-input
                                type="textarea"
                                :rows="5"
                                resize="none"
                                placeholder="请输入内容"
                            >
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="common-borderTopLeft">
                            <el-row class="common-padding common-borderBottom">
                                <span class="common-title">Forwarding Agent and References</span>
                                <el-input
                                    type="textarea"
                                    :rows="3"
                                    resize="none"
                                    placeholder="请输入内容"
                                >
                                </el-input>
                            </el-row>
                            <el-row class="common-padding">
                                <span class="common-title">Point and Country of Origin</span>
                                <span>ssdasdada</span>
                            </el-row>
                        </el-col>
                    </el-row>
                     <el-row class="fourth">
                        <el-col :span="12" class="common-borderTop">
                            <el-row class="common-padding">
                                <el-col :span="12">
                                    <span class="common-title">3. Consignee  Insert Name Address and Phone / Address</span>
                                </el-col>
                                <el-col :span="12">
                                    <span>(It is agreed that no responsibility shall attach to the Carrier or his agents for failure to notify)</span>
                                </el-col>
                                <el-input
                                    type="textarea"
                                    :rows="5"
                                    resize="none"
                                    placeholder="请输入内容"
                                >
                                </el-input>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="common-borderTopRight common-padding">
                                    <span class="common-title">4. Combined Transport*   PreCarriage By</span>
                                    <span>OOCL2020001</span>
                                </el-col>
                                <el-col :span="12" class="common-borderTop common-padding">
                                    <span class="common-title">5. Combined Transport*   Place of Receipt</span>
                                    <span>OOCL2020001</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="common-borderTopRight common-padding">
                                    <span class="common-title">6. Ocean Vessle Voy. No. </span>
                                    <span>OOCL2020001</span>
                                </el-col>
                                <el-col :span="12" class="common-borderTop common-padding">
                                    <span class="common-title">7. Port of Loading</span>
                                    <span>OOCL2020001</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" class="common-borderTopRight common-padding">
                                    <span class="common-title">8. Port of Discharge </span>
                                    <span>OOCL2020001</span>
                                </el-col>
                                <el-col :span="12" class="common-borderTop common-padding">
                                    <span class="common-title">5. Combined Transport*   Place of Receipt</span>
                                    <span>OOCL2020001</span>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12" class="common-borderTopLeft">
                            <el-row>
                                <el-col class="common-padding">
                                    <span class="common-title">Also Notify Party-routing & instructions</span>
                                    <el-input
                                        type="textarea"
                                        :rows="8"
                                        resize="none"
                                        placeholder="请输入内容"
                                    >
                                    </el-input>
                                </el-col>
                                <el-col>
                                    <el-row>
                                        <el-col :span="12" class="common-borderTopRight common-padding">
                                            <span class="common-title">Service Contract No.</span>
                                            <span>OOCL2020001</span>
                                        </el-col>
                                        <el-col :span="12" class="common-borderTop common-padding">
                                            <span class="common-title">Commidity Code</span>
                                            <span>OOCL2020001</span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col class="common-borderTop common-padding">
                                    <span class="common-title">Type of Movement</span>
                                    <span>OOCL2020001</span>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row class="fifth">
                        <el-col class="common-borderBottom">
                            <el-row>
                                 <el-col :span="6" class="fifth-title common-borderTopRight">
                                    <el-row>
                                        <span class="common-title">Marks & Nos. Container/Seal No.</span>
                                    </el-row>
                                </el-col>
                                <el-col :span="4" class="fifth-title common-borderTopRight">
                                    <el-row>
                                        <span class="common-title">No. of Container of Packages</span>
                                    </el-row>
                                </el-col>
                                <el-col :span="6" class="fifth-title common-borderTop">
                                    <el-row>
                                        <span class="common-title">Description of Goods (If Dangerous Goods. See Clause 20)</span>
                                    </el-row>
                                </el-col>
                                <el-col :span="4" class="fifth-title common-borderTopLeft">
                                    <el-row>
                                        <span class="common-title">Gross Weight</span>
                                    </el-row>
                                </el-col>
                                <el-col :span="4" class="fifth-title common-borderTopLeft">
                                    <el-row>
                                        <span class="common-title">Measurement</span>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col>
                            <el-row>
                                <el-col :span="6" class="common-padding common-borderRight">
                                    <el-input
                                        type="textarea"
                                        :rows="5"
                                        resize="none"
                                        placeholder="N/M"
                                    >
                                    </el-input>
                                    <span class="fifth-padding fifth-bottom">
                                        TOTAL:
                                    </span>
                                </el-col>
                                <el-col :span="4" class="common-borderRight">
                                    <el-row class="common-padding">
                                        <el-input
                                            type="textarea"
                                            :rows="5"
                                            resize="none"
                                            placeholder="N/M"
                                        >
                                        </el-input>
                                    </el-row>
                                    <el-row class="">
                                        <span class="fifth-bottom fifth-padding fifth-padding-ex common-borderTopDashed">
                                            22 PACKAGES
                                        </span>
                                    </el-row>
                                </el-col>
                                <el-col :span="6" class="common-padding">
                                    <el-input
                                        type="textarea"
                                        :rows="6"
                                        resize="none"
                                        placeholder="N/M"
                                    >
                                    </el-input>
                                </el-col>
                                <el-col :span="4" class="common-borderLeft">
                                    <el-row class="common-padding">
                                        <el-input
                                            type="textarea"
                                            :rows="5"
                                            resize="none"
                                            placeholder="N/M"
                                        >
                                        </el-input>
                                    </el-row>
                                    <el-row class="">
                                        <span class="fifth-bottom fifth-padding fifth-padding-ex common-borderTopDashed">
                                            22 PACKAGES
                                        </span>
                                    </el-row>
                                </el-col>
                                <el-col :span="4" class="common-borderLeft">
                                    <el-row class="common-padding">
                                        <el-input
                                            type="textarea"
                                            :rows="5"
                                            resize="none"
                                            placeholder="N/M"
                                        >
                                        </el-input>
                                    </el-row>
                                    <el-row class="">
                                        <span class="fifth-bottom fifth-padding fifth-padding-ex common-borderTopDashed">
                                            22 PACKAGES
                                        </span>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col class="common-borderTopDashed">
                            <el-row>
                                <el-col :span="6" class="common-padding common-borderRight">
                                    <el-input
                                        type="textarea"
                                        :rows="5"
                                        resize="none"
                                        placeholder="N/M"
                                    >
                                    </el-input>
                                </el-col>
                                <el-col :span="4" class="common-borderRight fifth-height">

                                </el-col>
                                <el-col :span="6" class="common-padding fifth-height">

                                </el-col>
                                <el-col :span="4" class="common-borderLeft fifth-height">

                                </el-col>
                                <el-col :span="4" class="common-borderLeft fifth-height">

                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col class="common-borderTopDashed">
                            <el-row>
                                <el-col :span="6" class="common-padding common-borderRight">
                                    <el-input
                                        type="textarea"
                                        :rows="1"
                                        resize="none"
                                        placeholder="N/M"
                                    >
                                    </el-input>
                                </el-col>
                                <el-col :span="4" class="common-borderRight fifth-height49">

                                </el-col>
                                <el-col :span="6" class="common-padding fifth-height49">

                                </el-col>
                                <el-col :span="4" class="common-borderLeft fifth-height49">

                                </el-col>
                                <el-col :span="4" class="common-borderLeft fifth-height49">

                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col class="common-borderTopDashed">
                            <el-row>
                                <el-col :span="6" class="common-padding common-borderRight">
                                    <el-input
                                        type="textarea"
                                        :rows="1"
                                        resize="none"
                                        placeholder="N/M"
                                    >
                                    </el-input>
                                </el-col>
                                <el-col :span="4" class="common-borderRight fifth-height49">

                                </el-col>
                                <el-col :span="6" class="common-padding fifth-height49">

                                </el-col>
                                <el-col :span="4" class="common-borderLeft fifth-height49">

                                </el-col>
                                <el-col :span="4" class="common-borderLeft fifth-height49">

                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col class="common-borderTop">
                            <el-row>
                                <el-col :span="5" class="common-padding common-borderRight">
                                    <span class="common-title">Declared Cargo Value USS</span>
                                </el-col>
                                <el-col :span="19" class="common-padding">
                                    <span class="common-title">Description of Contents for Shipper`s Use Only (Not part of this B/L Contract)</span>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col class="common-borderTop">
                            <el-row>
                                <el-col :span="6" class="common-padding">
                                    <span class="common-title">Total Number of Containers and / or Packages (In Words) Subject to Clause 7 Limitation</span>
                                </el-col>
                                <el-col :span="18" class="common-padding">
                                    <el-input
                                        type="textarea"
                                        :rows="3"
                                        resize="none"
                                        placeholder="请输入内容"
                                    >
                                    </el-input>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="panel-top">
                <el-col>
             <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">提单处理说明</span>
                </el-col>
                </div>
              </el-row>
                    <el-row class="content-panel">
                         <el-col>
                            <el-row>
                                客户在此提出的指示, 承运人可能会因为操作限制只能部分接受或者全部不能接受, 对于特殊指示的处理结果, 请仔细核对承运人在线或者线下反馈的提单草稿样本, 或联系承运人当地办公室, 承运人不承担按照客户的要求交付提单所产生的风险和责任
                            </el-row>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
             <el-row class="btn-container panel-top" type="flex" justify="end" align="middle">
                <el-button type="primary" size="mini">提单确认</el-button>
                <el-button type="primary" size="mini">关闭</el-button>
            </el-row>
		</el-form>
	</div>
</template>

<script>
export default {
    name: 'onlineOrderMatching',
    data() {
        return {
            onlineOrderMatchingForm: {}
        };
    },
    async created() {

    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style scoped lang="scss">
   .matching_title {
       color: #0000FF;
       font-weight: bold;
       font-size: 15px;
   }
   .matching_tip {
       color: #3390FF;
       .link_go {
            color: #FF3737;
            border-bottom: 1px solid #FF3737;
       }
   }
   .matching-body {
       border: 2px solid #797979;
       .matching-body-title {
            height: 50px;
            padding: 8px;
            .matching-body-title-left {
                color: #FF3737;
            }
            .matching-body-title-right {
                font-weight: bold;
                font-size: 15px;
                height: 40px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }
       }
       .common-title {
           display: block;
           margin-bottom: 4px;
           font-weight: bold;
       }
       .common-borderTopRight {
           border-top: 2px solid #797979;
           border-right: 2px solid #797979;
       }
       .common-borderTopLeft {
           border-top: 2px solid #797979;
           border-left: 2px solid #797979;
       }
       .common-borderTop {
           border-top: 2px solid #797979;
       }
       .common-borderTopDashed {
           border-top: 2px dashed #797979;
       }
       .common-borderBottom {
           border-bottom: 2px solid #797979;
       }
       .common-borderRight {
           border-right: 2px solid #797979;
       }
       .common-borderLeft {
           border-left: 2px solid #797979;
       }
       .common-borderRightBottom {
           border-right: 2px solid #797979;
           border-bottom: 2px solid #797979;
       }
       .common-borderBottomThin {
           border-bottom: 1px solid #797979;
       }
       .common-padding {
           padding: 8px 4px;
       }
       .fifth-title {
           height: 40px;
           display: flex;
           align-items: center;
           justify-content: center;
           text-align: center;
       }
       .fifth-padding {
           display: block;
           padding-top: 8px;
        }
        .fifth-padding-ex {
           padding-left: 4px;
           padding-right: 4px;
        }
        .fifth-bottom {
            height: 30px;
        }
        .fifth-height {
            height: 131.33px;
        }
        .fifth-height49 {
            height: 49px;
        }
   }
   .content-panel {
        border: 2px dashed #797979;
        border-top: none;
        background-color: #ffffff;
        padding: 8px;
   }
</style>
